let endpoint = "";

if (process.env.NODE_ENV === "production") {
  endpoint = "https://crm.teatreden.pl";
} else {
  endpoint = "http://localhost:8000";
}

export { endpoint };
